import $axios from "../../api";
import FileSaver from "file-saver";

// MODULE NAME
const PREFIX = "website/article-category";

const state = {
    isLoading: false,
    createLoading: false,
    errors: "",
    isSuccess: false,
    list: [],
    logUser: [],
    page: 1,
    formData: null,
    detail: null,
};

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    SET_ERRORS(state, payload) {
        state.errors = payload;
    },
    SET_SUCCESS(state, payload) {
        state.isSuccess = payload;
    },
    SET_LIST(state, payload) {
        state.list = payload;
    },
    SET_USER_DATA(state, payload) {
        state.userData = payload;
    },
    SET_LOG_USER(state, payload) {
        state.logUser = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    SET_CREATE_LOAD(state, payload) {
        state.createLoading = payload;
    },
    SET_USER_ACCESS_DATA(state, payload) {
        state.userAccessData = payload;
    },
    SET_FORM_DATA(state, payload) {
        state.formData = payload;
    },
    SET_DETAIL(state, payload) {
        state.detail = payload;
    },
};

const actions = {
    getList({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(
                    `${PREFIX}/list?page=${state.page}&view=${
                        rootState.Main.view
                    }${payload || ""}`
                )
                .then((response) => {
                    commit("SET_LIST", response.data.data);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    getDetail({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(`${PREFIX}/view?id=${payload}`)
                .then((res) => {
                    commit("SET_DETAIL", res.data.data);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    createData({ commit, state, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        commit("SET_CREATE_LOAD", true);
        return new Promise((resolve, reject) => {
            $axios
                .post(`${PREFIX}/create`, payload)
                .then((response) => {
                    commit("SET_CREATE_LOAD", false);
                    commit("SET_SUCCESS", true);
                })
                .catch((error) => {
                    commit("SET_ERRORS", error.response.data.errors);
                    commit("SET_CREATE_LOAD", false);
                    commit("SET_SUCCESS", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    updateData({ commit, state, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        commit("SET_CREATE_LOAD", true);
        return new Promise((resolve, reject) => {
            $axios
                .post(`${PREFIX}/update`, payload)
                .then((response) => {
                    commit("SET_CREATE_LOAD", false);
                    commit("SET_SUCCESS", true);
                })
                .catch((error) => {
                    commit("SET_ERRORS", error.response.data.errors);
                    commit("SET_CREATE_LOAD", false);
                    commit("SET_SUCCESS", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    showHide({ commit, state, dispatch }, payload) {
        commit("SET_SUCCESS", false);
        return new Promise((resolve, reject) => {
            $axios
                .post(`${PREFIX}/showhide`, payload)
                .then((response) => {
                    commit("SET_SUCCESS", true);
                    dispatch(
                        "Main/globalSuccessSweetAlert",
                        response.data.message,
                        { root: true }
                    );
                })
                .catch((error) => {
                    commit("SET_SUCCESS", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
